export const configModelGroundForFP = {
  "Source": {
    "validtime": {
      "Type": "JSON",
      "url": "%numerical_db_gpv_url%/%data%/valid_times",
      "retain": true,
      "cache": true
    },
    "data": {
      "Type": "JSON",
      "url": "%numerical_db_gpv_url%/%data%/point_data?basetime=%basetime%&valid_time=%validTime%&LOND=%lon%&LATD=%lat%&level=%level%&element=AIRTMP&element=UWIND&element=VWIND&element=RHUM&element=LOWCLD&element=MIDCLD&element=UPRCLD",
      "retain": true,
      "cache": true
    }
  }
};
export const configModelUpperForFP = {
  "Source": {
    "validtime": {
      "Type": "JSON",
      "url": "%numerical_db_gpv_url%/%data%/valid_times",
      "retain": true,
      "cache": true
    },
    "data": {
      "Type": "JSON",
      "url": "%numerical_db_gpv_url%/%data%/point_data?basetime=%basetime%&valid_time=%validTime%&LOND=%lon%&LATD=%lat%&level=%level%&element=AIRTMP&element=UWIND&element=VWIND&element=RHUM",
      "retain": true,
      "cache": true
    }
  }
};
